import { buildTranscriptPreview } from './buildTranscriptPreview'
import { TRANSCRIPT_SEGMENT_STATUS } from '../types/transcriptSegment'

export function buildPersistedTranscriptSegments(segments = []) {
	if (!Array.isArray(segments) || segments.length === 0) {
		return []
	}

	return segments
		.filter(segment => segment?.status === TRANSCRIPT_SEGMENT_STATUS.FINAL)
		.sort((a, b) => a.chunkId - b.chunkId)
		.map(({ chunkId, text, startMs, endMs, speaker }) => ({
			chunkId: Number(chunkId),
			text: String(text || '').trim(),
			startMs: Number(startMs) || 0,
			endMs: Number(endMs) || 0,
			speaker: speaker ?? null,
		}))
}

export function buildSessionNotePayload({
	recordingId,
	studentId,
	recordedAt,
	durationMs,
	segments = [],
	language = 'en-US',
}) {
	const transcriptSegments = buildPersistedTranscriptSegments(segments)
	let transcriptText = buildTranscriptPreview(segments)
	if (!transcriptText && transcriptSegments.length > 0) {
		transcriptText = transcriptSegments
			.map(segment => String(segment.text || '').trim())
			.filter(Boolean)
			.join(' ')
	}

	return {
		recordingId: String(recordingId || ''),
		studentId: String(studentId || ''),
		recordedAt: recordedAt || new Date().toISOString(),
		durationMs: Number(durationMs) || 0,
		language: String(language || 'en-US'),
		transcriptText,
		transcriptSegments,
	}
}
